import { type UseQueryResult, useQuery } from 'react-query';
import {
  UserLogInAndSecurityService,
  // eslint-disable-next-line camelcase
  type Wealthlane_Dtos_LoginSecurityOptions_LoginSecurityOptionsForLoggedInUserDto,
} from '@wealthlane/api-services/wealthlane-identity-service';

const useGetSetOption = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_Dtos_LoginSecurityOptions_LoginSecurityOptionsForLoggedInUserDto[] | undefined,
  unknown
> => {
  const getSetOption = useQuery(['getSetOption'], async () => {
    return await handleRequest(
      UserLogInAndSecurityService.getApiIdentityApiAppUserLogInAndSecurityUserLoginSecurityOptions()
    );
  });

  return getSetOption;
};

export default useGetSetOption;
